/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2025-04-24 14:49:44
 *
 *******************************************************/
// @flow
import React from 'react';
import { Button } from '@shopify/polaris';
import { getAssetURL } from 'src/helpers';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { MerchandisingIcon } from 'src/components/containers/common/icon';
import { ADMIN_APP_ASSET_PATHS } from './assets';

export const COLUMN_CAMPAIGN = [
  { value: 'name', label: 'column01_Label', textAlign: 'left', width: 27, width2: 24 },
  { value: 'status', label: 'column02_Label', textAlign: 'center', width: 10, width2: 10 },
  { value: 'time', label: 'column03_Label', textAlign: 'left', width: 25, width2: 24 },
  { value: 'targeting', label: 'column04_Label', textAlign: 'left', width: 20, width2: 19 },
  { value: 'views', label: 'column05_Label', textAlign: 'center', width: 9, width2: 9 },
  { value: 'actions', label: 'column06_Label', textAlign: 'center', width: 9, width2: 14 }
];

// List of page type for recommendation widget
export const AB_CAMPAIGN_FEATURE_TYPES = {
  merchandising: {
    name: 'AdminHTML.ABTesting.Management.testingType_Merchandising',
    icon: MerchandisingIcon
  }
};

export const AB_TESTING_CAMPAIGN_STATUS = [
  {
    value: 'live',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Live'
  },
  {
    value: 'draft',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Draft'
  },
  {
    value: 'end',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Ended'
  }
];

export const CONFIG_AB_TESTING_TOUR = (i18n: Object, onAction) => {
  return [
    {
      selector: '[data-tour="pfs-introduce-ab-testing"]',
      position: 'bottom',
      content: () => {
        const el = document.querySelector('[data-tour="pfs-introduce-ab-testing"]');
        const rect = el?.getBoundingClientRect();
        const top = rect?.top ?? 0;
        const left = rect?.left ?? 0;
        const width = rect?.width ?? 0;
        return (
          <div
            className="BC-AB-testing-tour"
            style={{
              position: 'fixed',
              top: top + 75, // adjust as needed
              left: left - 350 + width * 2,
              zIndex: 9999,
              width: 360,
              backgroundColor: 'white',
              borderRadius: 8,
            }}>
            <div className="heading-tour">
              <h2>{i18n.translate('AdminHTML.ABTesting.Guide.popupLaunch_Heading')}</h2>
              <Button onClick={onAction} icon={MobileCancelMajor} plain />
            </div>
            <div className="image">
              <img
                width={300}
                alt={i18n.translate('AdminHTML.ABTesting.Guide.popupLaunch_Heading')}
                src={getAssetURL(ADMIN_APP_ASSET_PATHS.abTesting.guideBannerImg)}
              />
            </div>
            <div className="content-tour">
              {i18n.translate('AdminHTML.ABTesting.Guide.popupLaunch_Content')}
            </div>
            <div className="action-tour">
              <Button primary onClick={onAction}>
                {i18n.translate('AdminHTML.ABTesting.Guide.popupLaunch_Action')}
              </Button>
            </div>
          </div>
        );
      },
      style: {
        backgroundColor: 'white',
        padding: 0,
        width: '360px',
        maxWidth: 'unset',
        color: 'black',
        borderRadius: '8px',
        left: 0,
        top: 0,
        transform: 'unset'
      }
    }
  ];
};
export const MERCHANDISING_TARGETING_OPTIONS = [
  { value: 'search', label: 'AdminHTML.ABTesting.Item.step01_Settings02_Merchandising_Target01' },
  {
    value: 'collection',
    label: 'AdminHTML.ABTesting.Item.step01_Settings02_Merchandising_Target02'
  }
];

export const TARGETING_OPTIONS_BY_FEATURE = {
  merchandising: MERCHANDISING_TARGETING_OPTIONS
};

export const TEST_GOAL_OPTIONS = [
  { value: 'conversion-rate', label: 'AdminHTML.ABTesting.Item.step01_Settings04_Value01' },
  { value: 'revenue', label: 'AdminHTML.ABTesting.Item.step01_Settings04_Value02' }
];

export const CAMPAIGN_STATUS = {
  live: {
    status: 'success',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Live'
  },
  draft: {
    status: 'new',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Draft'
  },
  end: {
    status: 'new',
    label: 'AdminHTML.ABTesting.Management.campaignStatus_Ended'
  }
};

export const COLUMN_ANALYTICS = [
  { value: 'variation', label: 'card04_Column01', textAlign: 'left', width: 24 },
  { value: 'views', label: 'card04_Column02', textAlign: 'right', width: 19 },
  { value: 'traffic', label: 'card04_Column03', textAlign: 'right', width: 19 },
  { value: 'conversion', label: 'card04_Column04', textAlign: 'right', width: 19 },
  { value: 'revenue', label: 'card04_Column05', textAlign: 'right', width: 19 }
];

export const MAX_NUM_X_AXIS_POINTS_CAMPAIGN_CHART = 12;
